export default [
  {
    name: 'ssoLoginList',
    path: '/ssoLoginModel/ssoLoginList',
    component: () => import('@/views/ssoLoginModel/ssoLoginList.vue'),
    meta: {
      title: '主题配置'
    }
  },
  {
    name: 'ssoLoginDetail',
    path: '/ssoLoginModel/ssoLoginDetail',
    component: () => import('@/views/ssoLoginModel/ssoLoginDetail.vue'),
    meta: {
      parentAuth: '/ssoLoginModel/ssoLoginList',
      title: '创建配置'
    }
  }
]
